/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const DeliveryRecordStatusEnum = {
    failed: 'failed',
    pending: 'pending',
    sent: 'sent'
};
/**
 * Check if a given object implements the DeliveryRecord interface.
 */
export function instanceOfDeliveryRecord(value) {
    if (!('campaignId' in value) || value['campaignId'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    return true;
}
export function DeliveryRecordFromJSON(json) {
    return DeliveryRecordFromJSONTyped(json, false);
}
export function DeliveryRecordFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'campaignId': json['campaign_id'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'deliveredAt': json['delivered_at'] == null ? undefined : (new Date(json['delivered_at'])),
        'email': json['email'],
        'error': json['error'] == null ? undefined : json['error'],
        'schemaVersion': json['schemaVersion'] == null ? undefined : json['schemaVersion'],
        'status': json['status'] == null ? undefined : json['status'],
        'userId': json['user_id'],
    };
}
export function DeliveryRecordToJSON(json) {
    return DeliveryRecordToJSONTyped(json, false);
}
export function DeliveryRecordToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'campaign_id': value['campaignId'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'delivered_at': value['deliveredAt'] == null ? value['deliveredAt'] : value['deliveredAt'].toISOString(),
        'email': value['email'],
        'error': value['error'],
        'schemaVersion': value['schemaVersion'],
        'status': value['status'],
        'user_id': value['userId'],
    };
}
